<template>
  <div class="d-flex flex-wrap align-center period-picker" style="gap: 8px">
    <dropdown
      :value="value.preset"
      :items="presetOptions"
      item-text="label"
      item-value="value"
      hide-details
      color="white"
      style="width: 170px"
      @input="onPreset"
    />
    <date-picker
      v-if="value.preset === 'custom'"
      :value="[value.from, value.to]"
      hide-details
      style="min-width: 230px"
      @input="onCustom"
      color="white"
    />
  </div>
</template>

<script>
import { PERIOD_PRESETS, resolvePeriodPreset } from "./constants";

// v-model = { preset, from, to } (YYYY-MM-DD). "custom" otvara izbor opsega.
export default {
  name: "FinancePeriodPicker",

  props: {
    value: { type: Object, required: true },
  },

  computed: {
    presetOptions() {
      return [
        ...PERIOD_PRESETS.map((preset) => ({
          value: preset,
          label: this.$t(`finance_period_${preset}`),
        })),
        { value: "custom", label: this.$t("finance_period_custom") },
      ];
    },
  },

  methods: {
    onPreset(preset) {
      if (preset === "custom") {
        this.$emit("input", { ...this.value, preset });
        return;
      }
      this.$emit("input", { preset, ...resolvePeriodPreset(preset) });
    },
    onCustom(range) {
      if (!Array.isArray(range) || range.length === 0) return;
      const [a, b] = range.length === 1 ? [range[0], range[0]] : range;
      const [from, to] = a <= b ? [a, b] : [b, a];
      this.$emit("input", { preset: "custom", from, to });
    },
  },
};
</script>
